import React, { Suspense, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";

function Users() {
  const { user } = useContext(UserContext);
  console.log(user);
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    if (user && user.db_access == 1) fetchUsers();
  }, [user]);

  // Fetch users from the API
  const fetchUsers = async () => {
    try {
      const response = await fetch(api_endpoint + "/api/truckers", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      // Map the response data to fit the format you want
      const formattedUsers = data.map((u) => ({
        id: u.id,
        name: u.name,
        email: u.email,
        skills: u.skills,
        type: u.type,
      }));

      setUsers(formattedUsers); // Set the users into the state
      setFilteredUsers(formattedUsers); // Initially, display all users
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // Handle input change for filtering
  const handleInputChange = (e) => {
    setFilterText(e.target.value);
  };

  // Dynamically filter users when filterText changes
  useEffect(() => {
    if (filterText === "") {
      setFilteredUsers(users); // If filterText is empty, show all users
    } else {
      const filtered = users.filter((u) =>
        u.skills.some((skill) =>
          skill.toLowerCase().includes(filterText.toLowerCase())
        )
      );
      setFilteredUsers(filtered); // Update filtered users based on the filterText
    }
  }, [filterText, users]);

  return (
    <Suspense fallback={<div>Loading users...</div>}>
      <div className="chip-input-desktop">
        <input
          type="text"
          value={filterText}
          onChange={handleInputChange}
          placeholder="Keresés..."
        />
      </div>

      <div style={{ height: 30 }}></div>

      {filteredUsers.map((u, index) => (
        <div
          className="job-container"
          key={index}
          style={{
            display:
              user.type == "poster" && u.type === "admin" ? "none" : "block",
          }}
        >
          <div className="company-info">
            <p>{u.name}</p>
          </div>
          <div className="job-details">
            <a
              href={`mailto:${u.email}`}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "blue",
              }}
            >
              <h3>{u.email}</h3>
            </a>

            <div className="job-chips">
              {u.skills &&
                u.skills.map((skill, reqIndex) => (
                  <span
                    key={reqIndex}
                    className="chip"
                    onClick={() => setFilterText(skill)}
                  >
                    {skill}
                  </span>
                ))}
            </div>
          </div>
        </div>
      ))}
    </Suspense>
  );
}

export default Users;
